import React from 'react';

import { withRouter } from 'src/helpers';
import { BookAppointment } from 'src/components/appointments/Book';
import { createBookContext } from 'src/components/appointments/Book/context';

import adminBookConfig from './config.admin';

// One context for the whole admin app (own model instances, admin endpoints)
const adminBookContext = createBookContext(adminBookConfig);

const AdminBook = (props) => <BookAppointment {...props} {...adminBookContext} />;

export default withRouter(AdminBook);
